<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <div>
      <b-form-select
        id="kydir"
        v-model="selected"
        :options="options"
        :state="selected === null ? false : true"
      />
      <b-card-text class="mt-1 mb-0" />
    </div>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">

      <!-- Bookmarks Container -->
      <bookmarks />
    </div>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="success"
      size="sm"
      @click="alert1"
    >

      Online İşlemler
      <b-spinner
        small
        type="grow"
        label="Loading..."
      />
    </b-button>
    <b-navbar-nav class="nav align-items-center ml-auto">
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav,
  BButton, BSpinner, BFormSelect,
} from 'bootstrap-vue'

import UserDropdown from './components/UserDropdown.vue'

export default {
  components: {
    BLink,
    BFormSelect,
    // Navbar Components
    BNavbarNav,

    BSpinner,

    UserDropdown,
    BButton,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      selected: null,
      options: [
        { value: null, text: 'Enerji Türünü Seçiniz', disabled: true },
        { value: 'a', text: 'Elektrik' },
        { value: 'b', text: 'Doğalgaz' },
        { value: 'c', text: 'Su' },
        { value: 'd', text: 'Güneş Enerji Sistemleri' },
      ],
    }
  },
  methods: {
    alert1() {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('Online Ödemeler Platformu Sayfasına Yönlendiriliyorsunuz...', {
          title: 'Ödeme Platformu',
          size: 'bg',
          okVariant: 'success',
          okTitle: 'Onayla',
          cancelTitle: 'İptal',
          cancelVariant: 'danger',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          this.boxTwo = value
        })
    },
  },
}
</script>
  <style>
      .online {
      animation: blinker 0.9s linear infinite;
      color: #1c87c9;
      }
      @keyframes blinker {
      50% { opacity: 0; }
      }
#kaydirtarih{
  float: left;
}
    </style>
